import PensionsModule from '@features/Attestation/Attestation.Module';

const Attestation = () => {
  return <PensionsModule />;
};

export default Attestation;
